// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.time-badge_wrapper__Wp0D- {
  flex-shrink: 0;

  padding: 2px 10px 2px 10px;
  border-width: 0;
  border-radius: 3px;

  font-size: 12px;
  font-weight: 700;
  color: #ffffff;

  forced-color-adjust: preserve-parent-color;
  background-color: rgba(0, 0, 0, 0.5);
}
.time-badge_wrapper__Wp0D-.time-badge_active__sLI8V {
    background-color: var(--primaryColor);
  }
@media (prefers-contrast: more) {
    .time-badge_wrapper__Wp0D- {
      border: 1px solid var(--borderColor);
    }
  }
@media (forced-colors: active) {
    .time-badge_wrapper__Wp0D- {
      border: 1px solid ButtonBorder;
    }

    .time-badge_wrapper__Wp0D-.time-badge_active__sLI8V {
      color: HighlightText;
      background-color: Highlight;
    }
  }
`, "",{"version":3,"sources":["webpack://./src/components/time-badge/time-badge.module.css"],"names":[],"mappings":"AAAA;EACE,cAAc;;EAEd,0BAA0B;EAC1B,eAAe;EACf,kBAAkB;;EAElB,eAAe;EACf,gBAAgB;EAChB,cAAc;;EAEd,0CAA0C;EAC1C,oCAAoC;AAsBtC;AApBE;IACE,qCAAqC;EACvC;AAEA;IACE;MACE,oCAAoC;IACtC;EACF;AAEA;IACE;MACE,8BAA8B;IAChC;;IAEA;MACE,oBAAoB;MACpB,2BAA2B;IAC7B;EACF","sourcesContent":[".wrapper {\n  flex-shrink: 0;\n\n  padding: 2px 10px 2px 10px;\n  border-width: 0;\n  border-radius: 3px;\n\n  font-size: 12px;\n  font-weight: 700;\n  color: #ffffff;\n\n  forced-color-adjust: preserve-parent-color;\n  background-color: rgba(0, 0, 0, 0.5);\n\n  &.active {\n    background-color: var(--primaryColor);\n  }\n\n  @media (prefers-contrast: more) {\n    & {\n      border: 1px solid var(--borderColor);\n    }\n  }\n\n  @media (forced-colors: active) {\n    & {\n      border: 1px solid ButtonBorder;\n    }\n\n    &.active {\n      color: HighlightText;\n      background-color: Highlight;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `time-badge_wrapper__Wp0D-`,
	"active": `time-badge_active__sLI8V`
};
module.exports = ___CSS_LOADER_EXPORT___;
